import { useEffect, useState } from 'react'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { useRouter } from '../RoutingProvider'
import { UrlQuery, UseQueryHook } from '../types'

const useObservableState = <T>(obs: Observable<T>, initialVal: T) => {
    const [v, setV] = useState(initialVal)

    useEffect(() => {
        const sub = obs.subscribe(v => setV(v))
        return () => {
            sub.unsubscribe()
        }
    }, [])

    return v
}

// TODO add support for key, todo serialization nof deep object into query
export const useQuery: UseQueryHook = <T extends UrlQuery>() => {
    const r = useRouter()

    const query = useObservableState(
        r.locationChanges().pipe(map(l => l.query)),
        r.getLocation().query
    )

    return [
        // @ts-ignore
        query as T,
        (t: T) => r.pushQuery(t),
        (t: T) => r.mergeQuery(t)
    ]
}
